export const shopLogClstag = {
  mainGoodBtnClick: 'pageclick|keycount|yx_shop_1628613788465|46',
  searchBtnClick: 'pageclick|keycount|yx_shop_1628613788465|51',
  saveBtnClick: 'pageclick|keycount|yx_shop_1628613788465|47',
  editBtnClick: 'pageclick|keycount|yx_shop_1628613788465|49',
  mutSaveBtnClick: 'pageclick|keycount|yx_shop_1628613788465|48',
  changePicClick: 'pageclick|keycount|yx_shop_1628613788465|50',
  batchApplyClick: 'pageclick|keycount|supplement_material_1667200329665|1',
  batchModalOkClick: 'pageclick|keycount|supplement_material_1667200329665|3',
  batchModalCancelClick: 'pageclick|keycount|supplement_material_1667200329665|4',
}
